import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Field, Input, Btn, Card } from "@/components/erp/ui";
import { resetMediaCfg } from "@/components/erp/prod/ProdInputs";

const F = [["img_max_kb", "Target ukuran foto (KB)", "50–1000"], ["img_max_px", "Sisi terpanjang foto (px)", "640–4000"], ["video_max_mb", "Ukuran video maksimal (MB)", "2–200"], ["video_max_sec", "Durasi video maksimal (detik)", "5–600"]];

export const MediaSettings = () => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/media/settings").then(({ data }) => setV(data)).catch(() => {}); }, []);
  if (!v) return null;
  const save = async () => {
    try { const { data } = await api.put("/media/settings", Object.fromEntries(F.map(([k]) => [k, +v[k]]))); setV({ ...v, ...data }); resetMediaCfg(); toast.success("Pengaturan foto & video disimpan"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const photosPerYear = 200 * 365; const gb = (photosPerYear * v.img_max_kb) / 1048576;
  return (
    <Card className="p-5" data-testid="media-settings">
      <h3 className="font-semibold mb-1">Kompres foto & batas video</h3>
      <p className="text-xs text-slate-500 mb-4">Semua foto yang diupload otomatis dikecilkan (di HP sebelum dikirim, dan di server). Video di atas batas ditolak. Berlaku untuk upload baru.</p>
      <div className="grid sm:grid-cols-4 gap-3">{F.map(([k, l, r]) => (
        <Field key={k} label={`${l} · ${r}`}><Input type="number" data-testid={`media-${k}`} disabled={!v.is_owner} value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} /></Field>
      ))}</div>
      <p className="text-[11px] text-slate-500 mt-2" data-testid="media-estimate">Perkiraan: 200 foto/hari × {v.img_max_kb} KB ≈ {gb.toFixed(1)} GB per tahun ≈ {(gb * 10).toFixed(0)} GB untuk 10 tahun (foto saja).</p>
      {v.is_owner && <Btn className="mt-3" data-testid="media-save" onClick={save}>Simpan</Btn>}
    </Card>
  );
};
